<template>
  <div class="urgency-ticker">
    <i class="urgency-ticker__icon"></i>
    <p v-html="formattedText" class="urgency-ticker__text"></p>
  </div>
</template>

<script lang="ts">
import {
  Component,
  Prop,
  Provide,
  Vue,
  Watch
} from 'vue-property-decorator';
import { tokenService } from '../../services/TokenService';

@Component
export default class UrgencyTickerComponent extends Vue {
  @Prop({ default: '4 people have requested a manufacturerName quote in the last 15 minutes' })
  public text!: string;

  public get formattedText() {
    return tokenService.replaceToken(this.text);
  }
}
</script>
